import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumBillingPlanStatus implements BaseEnumType {
  private static allValues: EnumBillingPlanStatus[] = []; // make sure this is top-most
  
  public static trialling = new EnumBillingPlanStatus(0, "Trialling", "enum_billing_plan_status_trialling");
  public static triallingAndCommitted = new EnumBillingPlanStatus(1, "TriallingAndCommitted", "enum_billing_plan_status_trialling_and_committed");
  public static active = new EnumBillingPlanStatus(2, "Active", "enum_billing_plan_status_active");
  public static pastDue = new EnumBillingPlanStatus(3, "PastDue", "enum_billing_plan_status_past_due");
  public static cancelling = new EnumBillingPlanStatus(4, "Cancelling", "enum_billing_plan_status_cancelling");
  public static cancelled = new EnumBillingPlanStatus(5, "Cancelled", "enum_billing_plan_status_cancelled");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumBillingPlanStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isTrialling() { return this === EnumBillingPlanStatus.trialling; }
  public isTriallingAndCommitted() { return this === EnumBillingPlanStatus.triallingAndCommitted; }
  public isActive() { return this === EnumBillingPlanStatus.active; }
  public isPastDue() { return this === EnumBillingPlanStatus.pastDue; }
  public isCancelling() { return this === EnumBillingPlanStatus.cancelling; }
  public isCancelled() { return this === EnumBillingPlanStatus.cancelled; }

  public static getValues(): readonly EnumBillingPlanStatus[] {
    return EnumBillingPlanStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumBillingPlanStatus[] {
    return EnumBillingPlanStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumBillingPlanStatus {
    const found = EnumBillingPlanStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumBillingPlanStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumBillingPlanStatus): EnumBillingPlanStatus {
    const found = name ? EnumBillingPlanStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumBillingPlanStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumBillingPlanStatus>): boolean {
    return this.key === other?.key;
  }
}